import React from "react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";
import { useLang } from "@/context/LanguageContext";

export default function ThemeToggle({ className = "" }) {
  const { t } = useLang();
  const { theme, toggle } = useTheme();
  const dark = theme === "dark";
  return (
    <button
      onClick={toggle}
      data-testid="theme-toggle"
      aria-label={dark ? t("hc.switchToLightMode") : t("hc.switchToDarkMode")}
      className={`relative h-9 w-9 grid place-items-center rounded-full border border-border hover:bg-secondary transition-colors ${className}`}
    >
      {dark ? <Sun size={18} className="text-amber-400" /> : <Moon size={18} className="text-findo-navy" />}
    </button>
  );
}
